"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Permisos = void 0;
var react_1 = __importDefault(require("react"));
var recoil_1 = require("recoil");
var permisos_1 = require("../../hooks/permisos");
var buttons_1 = require("../../ui/buttons");
var texts_1 = require("../../ui/texts");
var index_css_1 = __importDefault(require("./index.css"));
function Permisos() {
    var setPermisosDeUbicacion = (0, recoil_1.useSetRecoilState)(permisos_1.permisosDeUbicacion);
    function permitirUbicacion() {
        setPermisosDeUbicacion(true);
        navigator.geolocation.getCurrentPosition(function () { });
    }
    return (react_1.default.createElement("div", { className: index_css_1.default["permisos-container"] },
        react_1.default.createElement(texts_1.CustomLongText, null, "Para ver las mascotas reportadas cerca tuyo necesitamos permiso para conocer tu ubicaci\u00F3n."),
        react_1.default.createElement(buttons_1.MainButton, { color: "pink", onClick: permitirUbicacion }, "Dar mi ubicacion")));
}
exports.Permisos = Permisos;
